import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const BookSwaps = () => <EventCategoryPage config={EVENT_CATEGORIES['book-swaps']} data-id="element-9847" data-mp="15v37cdzdaypa" />;
export default BookSwaps;